exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .highlight-first tag:first-of-type {\n  background: #FFF80D !important;\n}\n::ng-deep .ng2-dropdown-menu {\n  left: unset !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/add-users/existing-and-new/existing-and-new.component.less
// module id = ../../../../../src/app/dashboard/program-list/program/add-users/existing-and-new/existing-and-new.component.less
// module chunks = 2